import $ from 'jquery';

const collapse = {
    init() {
        $(document).ready(() => {
            this.setupCollapse();
        });
    },
    setupCollapse() {
        $(document).on('click', '.collapse-arrow', (e) => {
            $(e.currentTarget).toggleClass('active');
            return false;
        });
    },
};

export default collapse;
